import { AuthMutation, SignInByEmailMutation } from '../graphql/graphql';

export const isSuccessfulSignIn = (
  data: AuthMutation | null | undefined | SignInByEmailMutation
) => Boolean(data?.signIn?.profile?.id) && !data?.signIn?.errors.length;
